import ReactGA from "react-ga4";

const useAnalytics = () => {
  const trackEvent = (action, category, label, value, membership) => {
    const membership_number = membership ? membership.membership : "unknown";
    if (!value) value = 1;
    ReactGA.event({ action, category, label, value, membership_number });
  };

  const trackException = (description) => {
    ReactGA.gtag("event", "exception", {
      description: description,
      fatal: false
    });
  };

  return { trackEvent, trackException };
};

export default useAnalytics;